import React from 'react'

const Circle = ({ image }) => {
    return (
        <div style={{ border: "3px solid white", borderRadius: "50%", height: "100px", width: "100px", margin: "auto", background: "#1CA069", backgroundImage: `url(${image})`, backgroundRepeat: "no-repeat", backgroundPosition: "center" }}></div>
    )
}

export default Circle